import styled from 'styled-components';
import { lightTheme } from '../../styles/theme';

export const Label = styled.p`
	margin-bottom: 6px;
	font-size: 14px;
	color: ${lightTheme.select.label};
`;

export const DropdownContainer = styled.div`
	position: relative;
`;

export const SelectBox = styled.div<{ disabled?: boolean }>`
	position: relative;
	z-index: 1;
	display: flex;
	align-items: center;
	flex-wrap: wrap;
	justify-content: space-between;
	padding: 2px;
	border-radius: 12px;
	height: 44px;

	box-shadow: 0px 4px 6px -1px rgba(0, 0, 0, 0.1),
		0px 2px 4px -1px rgba(0, 0, 0, 0.06);
	background: ${({ disabled }) =>
		disabled
			? lightTheme.select.disabledBackground
			: lightTheme.select.background};
	cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
	pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
`;

export const Placeholder = styled.p`
	margin-left: 12px;
	font-size: 14px;
	color: ${lightTheme.select.placeholder};
`;

export const SelectedTitle = styled.p`
	margin-left: 12px;
	font-size: 14px;
	font-weight: 400;
	color: ${lightTheme.select.label};
`;

export const SelectedItems = styled.div`
	width: calc(100% - 35px);
	display: flex;
	overflow: scroll;

	scrollbar-width: none;
	-ms-overflow-style: none;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export const SelectedItem = styled.div`
	position: relative;
	z-index: 2;
	display: flex;
	align-items: center;
	background: ${lightTheme.select.activeBackground};
	padding: 12px 16px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 14px;
	height: 40px;
	font-weight: 500;
	border-radius: 10px;
	text-wrap: nowrap;
	margin-left: 4px;
	cursor: pointer;

	&:nth-of-type(1) {
		margin-left: 0;
	}

	a {
		margin-left: 6px;
	}
`;

export const OptionsList = styled.ul<{
	isOpen: boolean;
	customHeight?: number;
}>`
	position: absolute;
	z-index: 100;
	margin-top: 6px;
	width: 100%;
	padding: 2px;
	border-radius: 12px;
	list-style: none;
	display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
	overflow-y: auto;
	background: ${lightTheme.select.background};
	box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1),
		0px 4px 6px -2px rgba(0, 0, 0, 0.05);
	max-height: ${({ customHeight }) => customHeight && customHeight + 'px'};
	overflow-y: ${({ customHeight }) => customHeight && 'scroll'};
`;

export const Option = styled.li<{ selected: boolean; disabled?: boolean }>`
	border-radius: 12px;
	margin-top: 2px;
	padding: 12px 16px;
	height: 44px;
	font-size: 14px;
	font-weight: 400;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
	transition: 0.1s;
	color: ${({ disabled }) =>
		disabled ? lightTheme.select.disabledLabel : lightTheme.select.label};
	background: ${({ selected, disabled }) =>
		selected
			? lightTheme.select.activeBackground
			: disabled
			? lightTheme.select.disabledBackground
			: 'transparent'};

	&:hover {
		background: ${({ disabled }) =>
			disabled
				? lightTheme.select.disabledBackground
				: lightTheme.select.activeBackground};
		transform: scale(1.05);
	}
`;

export const Circle = styled.div<{ type: 'default' | 'single' | 'multi' }>`
	width: 14px;
	height: 14px;
	border-radius: 999px;
	background: ${({ type }) => {
		if (type === 'default') return lightTheme.select.defaultCircle;
		if (type === 'single') return lightTheme.select.singleSelectedCircle;
		if (type === 'multi') return lightTheme.select.multiSelectedCircle;
	}};
`;

export const Chevron = styled.i`
	color: ${lightTheme.select.label};
	font-size: 14px;
	font-size: 12px;
	opacity: 0.5;
`;

export const Arrow = styled.div`
	margin-right: 12px;
`;

export const Cross = styled.div`
	display: flex;
	align-items: center;
	margin-left: 8px;
`;
